import { Grid } from "@mui/material";
import React from "react";
import "./itemdetail.css";
function ItemDetail() {
  return (
    <div className="auction_main">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10} lg={10}>
          <div className="item_card">
            {/* Grid for card */}
            <Grid
              container
              sx={{
                justifyContent: {
                  xs: "center",
                  sm: "center",
                  lg: "space-between",
                },
              }}
              alignItems="flex-start"
            >
              <Grid item xs={12} md={5} lg={5}>
                <img
                  src="./Assets/itemdetail_1.png"
                  alt=""
                  className="img_width"
                />
                <div className="seprator_item"></div>
                <Grid
                  container
                  alignItems="center"
                  sx={{
                    justifyContent: {
                      xs: "space-between",
                      sm: "space-around",
                      lg: "space-between",
                    },
                  }}
                >
                  <Grid item xs={6} md={6} lg={6} className="flex_item">
                    <img src="./Assets/itemdetail.png" alt="" />
                    <span className="id_text">@makinzi_jamy...</span>
                  </Grid>
                  <Grid item xs={2} md={2} lg={2} className="flex_item">
                    <img src="./Assets/Heart.png" alt="" />
                    <span className="id_text">2.1K</span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <h1 className="item_heading">Dancing Girl</h1>
                {/* grid */}
                <Grid
                  container
                  sx={{
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      lg: "space-between",
                    },
                  }}
                  alignItems="center"
                >
                  <Grid item xs={12} md={8} lg={8}>
                    <div className="item_btns">
                      <button className="btn_item_one">place bid</button>
                      <button className="btn_item_two">bids</button>
                      <button className="btn_item_two">History</button>
                    </div>
                  </Grid>
                  <Grid item xs={4} lg={2} className="flag_center">
                    <img src="./Assets/Flag.png" alt="" />
                    <img
                      src="./Assets/ShareNetwork.png"
                      alt=""
                      className="list_item_img"
                    />
                  </Grid>
                </Grid>
                {/* grid */}
                {/* Text Grid */}
                <Grid container>
                  <Grid item lg={12}>
                    <p className="item_para">
                      Hey guys! New exploration about NFT Marketplace Web
                      Design, this time I'm inspired by one of my favorite NFT
                      website called Rarible (with crypto payment)! What do you
                      think?
                    </p>
                  </Grid>
                </Grid>
                {/* Text Grid */}
                <div className="seprator_item"></div>
                <div className="seprator_item"></div>

                {/* GRID */}
                <Grid container justifyContent="space-around">
                  <Grid item lg={4}>
                    <div className="max_bid">
                      <p className="max_title">Minimum bid</p>
                      <h5 className="max_price">2.4000 ETH/ $4769.88</h5>
                    </div>
                  </Grid>
                  <Grid item lg={4}>
                    <div className="max_bid">
                      <p className="max_title">countdown</p>
                      <h5 className="max_price">23 : 54 : 04</h5>
                    </div>
                  </Grid>
                </Grid>
                {/* GRID */}
                <div className="item_seprator_2"></div>
                {/* BUTTON GRID */}
                <Grid container justifyContent="center">
                  <Grid item lg={4}>
                    <button className="common_btn">Buy Now</button>
                  </Grid>
                  <Grid item lg={4}>
                    {" "}
                    <button className="common_btn">Place Bid</button>
                  </Grid>
                </Grid>
                {/* BUTTON GRID */}
              </Grid>
            </Grid>
            {/* Grid for card */}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ItemDetail;
